/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { NzI18nService } from "ng-zorro-antd/i18n";

import { ModalButtonOptions, UiModalOptions } from "../../modal.models";
import { NzModalFooterComponent } from "ng-zorro-antd/modal";
import { TransformModalOptions } from "@webapp/ui/modal/utils/modal.utils";

@Component({
  selector: "div[ui-modal-footer]",
  exportAs: "UiModalFooterBuiltin",
  templateUrl: "modal-footer.component.html",
  host: {
    class: "ant-modal-footer",
  },
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UiModalFooterComponent extends NzModalFooterComponent {
  constructor(i18n: NzI18nService, public modalConfig: UiModalOptions) {
    super(i18n, TransformModalOptions(modalConfig));
    if (Array.isArray(modalConfig.footer)) {
      this.buttonsFooter = true;
      this.buttons = (modalConfig.footer as ModalButtonOptions[]).map(mergeDefaultOption);
    }
  }
}

function mergeDefaultOption(options: ModalButtonOptions): ModalButtonOptions {
  return {
    type: null,
    size: "default",
    autoLoading: true,
    show: true,
    loading: false,
    disabled: false,
    ...options,
  };
}
